// ============================================================
// Datei: src/pages/ressorts/bar/BarDesktop.jsx
//
// 🔥 ÄNDERUNGEN:
// - useState ergänzt (für Guest Modals)
// - GuestList korrekt eingebunden (richtiger Import + Props)
// - Edit + Delete Guest integriert (wie Infrastruktur / Kasse)
// - Modals hinzugefügt
// ============================================================

import React, { useState } from "react"; // 🔥 FIX: useState notwendig

// Components
import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

// Guests (🔥 WICHTIG: richtiger Pfad!)
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import VolunteerPool from "../../../components/VolunteerPool";

import "./bar.css";

const BarDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {

	// ============================================================
	// 🔥 STATE (wie Infrastruktur / Kasse)
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	// ============================================================
	// SHIFTS
	// ============================================================
	const bar = shifts.filter(s => s.shiftId >= 101 && s.shiftId <= 110);

	// ============================================================
	// TABS
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">

				{/* ============================================================
				   TAB BAR
				============================================================ */}
				<div className="tab-bar">
					{tabs.map(t => (
						<button
							key={t.id}
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">

					{/* ============================================================
					   HELPERS
					============================================================ */}
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Bar"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{/* ============================================================
					   SHIFTS
					============================================================ */}
					{activeTab === "shifts" && (
						<>
							<h3 className="bar-subheading"></h3>
							<ShiftTable shifts={bar} />
						</>
					)}

					{/* ============================================================
					   GUESTS ( FIX komplett wie Infrastruktur)
					============================================================ */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{/* ============================================================
					   EXTRAS
					============================================================ */}
					{activeTab === "extras" && <></>}

				</div>
			</div>

			{/* ============================================================
			   EDIT VOLUNTEER
			============================================================ */}
			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={() => reloadVolunteers?.()}
				/>
			)}

			{/* ============================================================
			   EDIT GUEST
			============================================================ */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ============================================================
			   DELETE GUEST
			============================================================ */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default BarDesktop;